<template>
  <div class="subTabClass" v-if="chartData1 !== null && chartData1.length">
    <div class="col-12 p-0 text-right">
        <uploadDownload />
        <select v-model="barMode" @change="getChartData">
          <option value="group">Group</option>
          <option value="stack">Stack</option>
        </select>
    </div>
    <PlotlyStackedBarChart
      class="svgChart"
      :data-set="chartData1"
      :xAxisType="xAxisType"
      :yAxisType="yAxisType"
      :margin="margin"
      :title="chartTitle"
      :name="name"
      :chartWidth="chartWidth"
      :chartHeight="chartHeight"
      :tickFormat="tickFormat"
      :commitName="'US IP CAGR'"
      :chartBarMode="barMode"
    >
    </PlotlyStackedBarChart>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//------------Import Charts----------
import PlotlyStackedBarChart from "@/components/charts/PlotlyCharts/StackedBarLineChart.vue";
import uploadDownload from "@/components/Common/upload-download/upload-download.vue";

export default {
  name: "USIPCAGR",
  components: {
    PlotlyStackedBarChart,
    uploadDownload,
  },
  computed: {
    ...mapGetters({
      usipcagr: "usipcagr",
      historyCalDropDown: "historyCalDropDown",
    }),
  },
  data() {
    return {
      chartTitle: "",
      name: "US IP CAGR",
      yAxisType: "linear",
      xAxisType: "date",
      barMode: 'group',
      chartWidth: 1250,
      chartHeight: 330,
      tickFormat: ",.0%",
      tickformatY: ",.0%",
      chartData: [],
      chartData1: null,
      margin: {
        l: 80,
        r: 80,
        b: 120,
        t: 40,
        pad: 2,
      },
    };
  },
  created() {
    this.getChartData();
  },
  methods: {
    ...mapActions(["getIframeChartDataById", "currentVersionUpdateHandler"]),
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },

    async getChartData() {
      let chart_API_Data = [];
      if (
        window.location.href.includes("auth_token=") &&
        !this.usipcagr.length
      ) {
        let data = await this.getIframeChartDataById(21);
        chart_API_Data = data;
      } else {
        chart_API_Data = this.usipcagr;
      }
      //------------Formatted Data------------
      if (chart_API_Data && chart_API_Data.length) {
        let formattedData = chart_API_Data.map(function(i) {
          return {
            bar1: +i.ip,
            bar2: +i.symbol,
            xField: i.date_label,
            year: +i.year,
          };
        });
        var filterValues = {};
        let uniqueValues = [
          ...new Set(chart_API_Data.map((item) => item["symbol"])),
        ];
        //Sort Data
        uniqueValues.sort();
        uniqueValues.sort();

        uniqueValues.forEach(function(i) {
          filterValues[i] = i;
        });
        formattedData.reverse();

        //------------Line Charts------------
        // console.log("uniqueValues=-=-", uniqueValues);
        var traceData = [];
        var colorArray = [
          "rgb(162, 218, 217)",
          "rgb(247, 196, 122)",
          "rgb(243, 239, 149)",
          "rgb(135, 135, 135)",
        ];

        for (var i = 0; i < uniqueValues.length; i++) {
          traceData.push({
            type: "bar",
            barmode: this.barMode,
            name: uniqueValues[i],
            x: [],
            y: [],
            xaxis: "x",
            yaxis: "y",
            year: [],
            tickformatY: ",.0%",
            marker: {
              color: colorArray[i],
            },
          });
          for (var j = 0; j < chart_API_Data.length; j++) {
            if (chart_API_Data[j].symbol == uniqueValues[i]) {
              traceData[i].x.push(chart_API_Data[j].date_label);
              traceData[i].y.push(chart_API_Data[j].ip);
              traceData[i].year.push(chart_API_Data[j].year);
            }
          }
        }
        // console.log("traceData-==-=", traceData);
        setTimeout(() => {
          if (traceData) {
            this.chartData1 = traceData;
          }
        }, 10);
      }
    },
  },
  watch: {
    usipcagr: {
        deep: true,
        handler() {
          this.chartData1 = null;
          this.getChartData();
          // this.loadChartData();
          // console.log("api responceeeeeeeeeeee", this.sectorValuations);
        }
    }
  },
  destroyed() {
    // console.log("destroyed++++", this.commitName);
    let payLoadObj = {
      table_pk: this.selected,
      chart_id: this.historyCalDropDown.current_version.chart_id,
      chartName: this.commitName,
    };
    let version = {
      version_data: payLoadObj,
      versionToggleValue: false,
    };
    this.currentVersionUpdateHandler(version);
  },
};
</script>
